import Box from '../UI/Box';
import ButtonBase from '../UI/ButtonBase';
import LogoBludocc from '../../assets/images/png/bludocc.png';
import { ReactComponent as LogoGreenfy } from '../../assets/images/svg/greenfy.svg';

import * as SC from './styles';
import Text from '../UI/Text';
import MenuOptions from './components/Menu';
import useHeader from './hooks/useHeader';

import ModalDefault from '../ModalDefault';
import { ReactComponent as FishIcon } from '../../assets/icons/peixe-icon.svg';
import { ReactComponent as ShrimpIcon } from '../../assets/icons/camarão-icon.svg';
import Icon from '../Icon';
import OptionsList from './components/OptionsList';
import MenuButton from './components/MenuButton';

const Header: React.FC = () => {
  const {
    itemsProfileData,
    itemsCyclesCode,
    itemsFarm,
    nameUser,
    nameCycle,
    nameProperty,
    openCyclesCodes,
    openFarm,
    openProfile,
    showModalCreateNewCycle,
    optionsMenuSide,
    valueSelectedMenuSide,
    openItems,
    isMobile,
    isTablet,
    paddingHeader,
    isMenuVisible,

    toggleItem,
    handleOpenChangeCyclesCodes,
    handleOpenChangeFarm,
    handleOpenChangeProfile,
    handleShowModalCreateNewCycle,
    createNewCycle,
    handleNavigate,
    handleSelectedOptions,
    handleIsMenuVisible,
  } = useHeader();

  const renderIconArrow = (open: boolean) => {
    if (open) {
      return <Icon iconName={'ExpandLess'} size={24} htmlColor="#005F47" />;
    }
    return <Icon iconName={'ExpandMore'} size={24} htmlColor="#005F47" />;
  };

  const renderAccordionItems = (
    items: typeof optionsMenuSide,
    level: number = 0
  ) => {
    return items.map(({ id, title, iconName, values, children, onClick }) => {
      const isSelected = handleSelectedOptions(values, valueSelectedMenuSide);
      const isOpen = openItems.includes(id);

      return (
        <Box key={id} flexDirection="column" width={'100%'}>
          <ButtonBase
            fontSize={17 - level * 2}
            color={'#005F47'}
            fontWeight={isSelected ? 700 - level * 100 : 500 - level * 100}
            background={isSelected ? '#B7FFBD80' : '#fff'}
            padding={25 - level * 6}
            paddingLeft={20}
            justifyContent="space-between"
            onClick={() => {
              if (children) {
                toggleItem(id);
              }
              if (onClick) {
                onClick();
              }
            }}
            alignItems="center"
            width={'100%'}
          >
            <Box alignItems="center" gap={10} width={'100%'}>
              {iconName && (
                <Icon iconName={iconName} size={24} htmlColor={'#005F47'} />
              )}
              {title}
            </Box>

            {children && renderIconArrow(isOpen)}
          </ButtonBase>

          {isOpen && children && (
            <Box
              gap={2}
              width={'100%'}
              justifyContent="center"
              background={'#fff'}
            >
              <Box paddingLeft={30 - level * 6}>
                <Box height={`100%`} width={2} background={'#005F47'} />
              </Box>

              <Box
                flexDirection="column"
                background={isSelected ? '#b7ffbd50' : '#fff'}
                width={'100%'}
              >
                {renderAccordionItems(children, level + 1)}
              </Box>
            </Box>
          )}
        </Box>
      );
    });
  };

  const renderHeaderContentDesktopOrMobile = () => {
    if (isMobile || isTablet) {
      return (
        <MenuButton handleClick={handleIsMenuVisible} open={isMenuVisible} />
      );
    }

    return (
      <Box gap={40}>
        <Box gap={20}>
          <MenuOptions
            title={nameProperty}
            iconName={'GiteOutlined'}
            iconLeft
            colorIcon="#005F47"
            colorBackground="#F1FFF2"
            children={() => (
              <OptionsList items={itemsFarm} selected={nameProperty} />
            )}
            handleOpenChange={handleOpenChangeFarm}
            open={openFarm}
          />
          <MenuOptions
            title={nameCycle}
            iconName={'TrackChangesOutlined'}
            iconLeft
            colorIcon="#005F47"
            colorBackground="#F1FFF2"
            children={() => (
              <OptionsList items={itemsCyclesCode} selected={nameCycle} />
            )}
            handleOpenChange={handleOpenChangeCyclesCodes}
            open={openCyclesCodes}
          />
        </Box>
        <MenuOptions
          title={nameUser}
          iconName={'AccountCircleOutlined'}
          iconRight
          colorIcon="#005F47"
          children={() => <OptionsList items={itemsProfileData} />}
          handleOpenChange={handleOpenChangeProfile}
          open={openProfile}
        />
      </Box>
    );
  };

  const renderMenuSideMobile = () => {
    return (
      <Box
        position="fixed"
        background="#00000080"
        height={'100%'}
        overflow="hidden"
        zIndex={5}
      >
        <Box
          width={'100%'}
          maxWidth={isMobile ? '100%' : 700}
          position="fixed"
          left={0}
          background={'#fff'}
          flexDirection="column"
          marginTop={90}
          alignItems="left"
          overflowY="auto"
          height={'100%'}
          maxHeight={'calc(100vh - 90px)'}
          transition="1s"
          transform={isMenuVisible ? 'translateX(0)' : 'translateX(-100%)'}
        >
          <Box gap={10} flexDirection="column" padding={20}>
            <MenuOptions
              title={nameUser}
              iconName={'AccountCircleOutlined'}
              iconLeft
              colorIcon="#005F47"
              children={() => <OptionsList items={itemsProfileData} />}
              handleOpenChange={handleOpenChangeProfile}
              open={openProfile}
            />

            <MenuOptions
              title={nameProperty}
              iconName={'GiteOutlined'}
              iconLeft
              colorIcon="#005F47"
              colorBackground="#F1FFF2"
              children={() => (
                <OptionsList items={itemsFarm} selected={nameProperty} />
              )}
              handleOpenChange={handleOpenChangeFarm}
              open={openFarm}
              maxWidthTitle={50}
            />
            <MenuOptions
              title={nameCycle}
              iconName={'TrackChangesOutlined'}
              iconLeft
              colorIcon="#005F47"
              colorBackground="#F1FFF2"
              children={() => (
                <OptionsList items={itemsCyclesCode} selected={nameCycle} />
              )}
              handleOpenChange={handleOpenChangeCyclesCodes}
              open={openCyclesCodes}
            />
          </Box>
          {renderAccordionItems(optionsMenuSide)}
        </Box>
      </Box>
    );
  };

  const renderMenuSideDesktopOrMobile = () => {
    if (isMobile || isTablet) {
      return renderMenuSideMobile();
    }
    return (
      <Box
        width={'100%'}
        maxWidth={290}
        position="fixed"
        left={0}
        padding={'25px 0'}
        paddingTop={0}
        background={'#fff'}
        borderRadius={16}
        flexDirection="column"
        marginTop={isTablet ? 160 : 115}
        marginBottom={20}
        alignItems="left"
        overflowY="auto"
        height={'100%'}
        maxHeight={'calc(100vh - 115px)'}
      >
        {renderAccordionItems(optionsMenuSide)}
      </Box>
    );
  };

  return (
    <>
      <Box
        width="100%"
        position="fixed"
        padding={paddingHeader}
        justifyContent="space-between"
        background={'#fff'}
        flexWrap="wrap"
        gap={20}
        zIndex={2}
      >
        <ButtonBase
          alignItems="center"
          gap={5}
          onClick={() => handleNavigate('/')}
          flexWrap="wrap"
          isNotHover
        >
          <SC.Logo src={LogoBludocc} width={80} />
          <Text>powered by</Text>
          <LogoGreenfy width={80} />
        </ButtonBase>

        {renderHeaderContentDesktopOrMobile()}
      </Box>

      {renderMenuSideDesktopOrMobile()}

      {/* TODO: REFACTOR */}
      <ModalDefault
        isOpen={showModalCreateNewCycle}
        title="Configuração de um novo ciclo de produção"
        onClose={handleShowModalCreateNewCycle}
        onBack={handleShowModalCreateNewCycle}
        maxHeight={300}
      >
        <Box display="flex" flexDirection="column" gap={1}>
          <Box borderRadius={16} padding={15} background={'#d8ffda'}>
            <Text fontSize={12} fontWeight={500} color="#2e7d32">
              Antes de criar um ciclo, você pode escolher o tipo de espécie que
              deseja. Somente será permitida a criação de viveiros da espécie
              que você configurou:
            </Text>
          </Box>
          <Box gap={10} marginTop={20}>
            <ButtonBase
              border={'2px solid #2e7d32'}
              padding={20}
              borderRadius={16}
              color="#2e7d32"
              width={'100%'}
              alignItems="center"
              justifyContent="center"
              fontWeight={700}
              fontSize={16}
              gap={10}
              onClick={() => createNewCycle('Camarão')}
            >
              <ShrimpIcon
                width={22}
                height={22}
                color={'#2e7d32'}
                fill={'#2e7d32'}
              />
              Criar ciclo para Camarões
            </ButtonBase>
            <ButtonBase
              border={'2px solid #2e7d32'}
              padding={20}
              borderRadius={16}
              color="#2e7d32"
              width={'100%'}
              alignItems="center"
              justifyContent="center"
              fontWeight={700}
              fontSize={16}
              gap={10}
              onClick={() => createNewCycle('Peixe')}
            >
              <FishIcon
                width={22}
                height={22}
                color={'#2e7d32'}
                fill={'#2e7d32'}
              />
              Criar ciclo para Peixes
            </ButtonBase>
          </Box>
        </Box>
      </ModalDefault>
    </>
  );
};

export default Header;
